// pages/QuestionnaireAGAFemale.tsx
import QuestionnaireForm from '../components/QuestionnaireForm';
const QuestionnaireAGAFemale = () => (
  <QuestionnaireForm questionFile="agafemale_questions.json" service="aga_female" />
);
export default QuestionnaireAGAFemale;
